/**
 * _admin — pathless layout route (TanStack Router convention).
 *
 * All routes inside `src/routes/_admin/` are automatically nested here.
 * The underscore prefix means this segment is NOT added to the URL path,
 * so `/routes/_admin/dashboard/index.tsx` is still accessible at `/dashboard`.
 *
 * This layout:
 *  1. Redirects unauthenticated users to /auth using the router context supabase
 *     client (Phase 3 migration pattern — context flows from router.tsx)
 *  2. Wraps all authenticated pages in the AdminShellLayout (sidebar + navbar)
 */

import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { AdminShellLayout } from "../components/AdminShellLayout";

export const Route = createFileRoute("/_admin")({
  // Central auth guard for all admin routes.
  // Uses context.supabase from router context (Phase 3 pattern).
  // Individual route beforeLoad guards are kept as defence-in-depth.
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return;
    const sb = context.supabase;
    if (!sb) return;
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <AdminShellLayout>
      <Outlet />
    </AdminShellLayout>
  );
}
